import {Stack} from "@mui/material";
import type {FieldResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, OperatorToggle, F, SummaryPill, SummaryPillRow, rowSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function FieldEditor({draft, editing, onChange}: ResolverEditorProps & { draft: FieldResolver }) {
    if (!editing) {
        return (
            <SummaryPillRow>
                <SummaryPill label="Field Name" value={draft.fieldName}/>
                <SummaryPill label="Match Type" value={draft.operator}/>
                <SummaryPill label="Field Value" value={draft.fieldValue}/>
            </SummaryPillRow>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.fieldName} placeholder="Field Name" onChange={(v) => upd("fieldName", v)} width="160px"/>
                <OperatorToggle
                    value={draft.operator}
                    options={[
                        {label: "Exact", value: "EXACT"},
                        {label: "Contains", value: "CONTAINS"},
                        {label: "Starts", value: "STARTS"},
                        {label: "Ends", value: "ENDS"},
                    ]}
                    onChange={(v) => upd("operator", v)}
                />
                <F value={draft.fieldValue} placeholder="Field Value" onChange={(v) => upd("fieldValue", v)} width="200px"/>
            </Stack>
        </Stack>
    );
}

export default FieldEditor;
